import { TYPE_TRACK } from '@chama/utils/functions/analytics';

export const MUTE_ORDER_SOUND = 'MUTE_ORDER_SOUND';
export const UNMUTE_ORDER_SOUND = 'UNMUTE_ORDER_SOUND';
export const SOUND_PLAYBACK = 'Order_SoundPlayback_mdt';
export const SOUND_WARNING_DISMISSED = 'Order_SoundWarningDismissed';

export const muteSound = () => {
  return dispatch => {
    dispatch({
      type: MUTE_ORDER_SOUND,
    });
  };
};

export const unmuteSound = () => {
  return dispatch => {
    dispatch({
      type: UNMUTE_ORDER_SOUND,
    });
  };
};

export const soundPlayed = () => {
  return dispatch => {
    dispatch({
      type: TYPE_TRACK,
      payload: {
        name: SOUND_PLAYBACK,
        properties: {
          isPlayed: true,
        },
      },
    });
  };
};

export const soundFailed = error => {
  return dispatch => {
    dispatch({
      type: TYPE_TRACK,
      payload: {
        name: SOUND_PLAYBACK,
        properties: {
          isPlayed: false,
          error,
        },
      },
    });
  };
};

export const soundWarningDismissed = () => {
  return dispatch => {
    dispatch({
      type: TYPE_TRACK,
      payload: {
        name: SOUND_WARNING_DISMISSED,
      },
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/order-sound.js